/* Cart-Drawer + window.Cart (Single Source of Truth). Alle Warenkorb-
   Operationen laufen hierueber, nie direkt /cart/add.js von anderswo.

   Cart.add(variantId, qty, opts) / Cart.addMulti(items, opts) -> Promise
     items: [id, ...] oder [{ id, quantity }, ...]; Adds laufen nacheinander.
     opts.open (Default true): Drawer sofort oeffnen (vor dem Request, mit
       Ladezustand). open:false: kein Oeffnen (auch kein fruehes), KEIN Fehler
       im geschlossenen Drawer - der Aufrufer zeigt beides selbst. Zaehler,
       Gratisversand-Leisten und 'cart:updated' laufen immer.
     resolved: kompletter Warenkorb (Format /cart.js). Sonderfall: add.js hat
       bestaetigt, der Warenkorb-Stand kam aber nicht (cart-state fehlt UND
       /cart.js scheitert) -> trotzdem Erfolg, resolved mit der add.js-Antwort
       (Artikel bzw. { items }), Event-detail.cart ist dann null.
     rejected: Error mit message === userMessage = Kundentext (dieselbe Logik
       wie im Drawer, nie Rohtexte), status (0 = Netz/Timeout), code, cause,
       shownInDrawer (true = der offene Drawer zeigt den Fehler schon; dann
       inline ohne zweites role=alert melden).
     Events: 'cart:add:success' { variantId|items, cart, opened },
             'cart:add:error' { variantId|items, error: Kundentext, status,
               opened, shown (= shownInDrawer) }.
   Cart.change(key, qty) / remove(key) -> Promise, je key serialisiert;
     Fehler wie bei add (Kundentext, shownInDrawer). Ueberlappen sich
     add/change, gleicht refresh() nach der letzten Antwort ab.
   Rollback nach Fehlern (rollback): refresh(); scheitert auch der (offline,
     Timeout), wird der zuletzt gezeichnete Stand (lastCart) neu gezeichnet -
     nie gesperrte Zeilen oder optimistische Mengen stehen lassen.
   bfcache (pageshow persisted): Express-Zustand neu lesen, einmal refresh().
   Cart.refresh(), Cart.open({ skipRefresh }), Cart.close(),
   Cart.userMessage(err), Cart.updateFsBars().
   Ohne window.Cart: Events 'cart:add' { variantId, quantity, open },
   'cart:open', 'cart:close'.

   Schnittstelle fuer Batch 3 (PDP, Cross-Sell ohne Drawer) - genau so halten:
     Cart.add(variantId, 1, { open: false }) -> Promise.
       Erfolg: resolved mit dem Warenkorb (bzw. Artikel, Sonderfall oben).
       Fehler: rejected mit Error, err.userMessage = err.message = Kundentext
       aus userMessage() (dieselbe Logik wie im Drawer). Bei open:false
       weder Oeffnen (auch kein fruehes) noch showError im geschlossenen
       Drawer; Header-Zaehler und 'cart:updated' laufen trotzdem.
     Aufrufer OHNE open:false (Drawer oeffnet sofort): bei err.shownInDrawer
       den Fehler NICHT zusaetzlich in ein eigenes role=alert schreiben
       (sonst doppelte Ansage). Offen: PDP-ATC bindAtc in main-product.liquid
       (gehoert zur PDP-Reihe, Batch 3).

   Aufbau (snippets/cart-drawer.liquid, Inhaber 15.10.2026: Platz fuer
   Artikel und Vorschlaege, Express zum Aufklappen unter "Zur Kasse").
   Alle Knoten dauerhaft im DOM, bei leerem Warenkorb hidden:
     [data-cart-fs]           Gratisversand-Leiste fest unter dem Kopf; syncFs
                              zieht Text/Fuellstand im vorhandenen Knoten nach.
     Scrollbereich (#cart-drawer-body), Reihenfolge = Fokusreihenfolge:
       [data-cart-items]      baut renderCart per innerHTML neu - NUR diesen,
       [data-cart-upsells]    Vorschlaege (applySections),
       [data-cart-extras]     Service-Flaeche ganz unten:
         [data-cart-service="summary"|"trust"]  Lieferzeit bzw. Widerruf +
                              Klarna: statische Knoten, nur ihr Inhalt wird
                              getauscht (syncSummaryNode/syncTrust, aus SERVICE
                              und nur wenn SERVICE.sig zum Warenkorb passt).
     [data-cart-footer]       fester Footer:
       [data-cart-footer-main]  baut renderCart neu (buildFooterMainHTML):
                              Zwischensumme, Zur Kasse, Sperr-Hinweis bei
                              Groessen-Konflikt,
       [data-cart-express]    statisch daneben: Trenner "oder" (nur offen
                              sichtbar, direkt unter "Zur Kasse"), Zeile
                              "Express-Checkout" ([data-cart-express-toggle],
                              aria-expanded) + Panel ([data-cart-express-panel])
                              mit Slot. Wallets EINMAL eingehaengt (syncExpress),
                              danach nur gezeigt/versteckt bzw. auf-/zugeklappt,
                              nie neu gesetzt (PayPal-iframe laedt sonst neu).
                              Auf-/Zuklappen: syncExpressUI (Zustand in
                              sessionStorage, ab 768 x 600 px immer offen),
       .cart-drawer__pay      statisch (6 Icons, per CSS weg bei Wallets).
   Rueckfall: Fehlen data-cart-fs/-extras (alte cart-drawer.liquid, falls
   Shopify die neue still verwirft), baut buildFooterMainHTML Leiste und
   Lieferzeit wie frueher in den Footer (SPLIT = false). Fehlen Zeile/Panel
   (Fassung vor dem Aufklappen), ist Express einfach immer offen.
   Service-Zeilen (Baustein 2): /cart.js kennt keine Metafelder, deshalb
   kommen Lieferzeit (Maximum custom.lieferzeit_werktage) und Widerrufs-
   Zeile (FLUM: custom.widerruf_hinweis) aus der Section cart-service -
   gebuendelt in der add/change-Antwort (SECTIONS), sonst einmal per GET
   ROUTES.cart + '?sections=cart-service' (ensureServiceFresh: nur wenn die
   Signatur nicht zum gezeichneten Warenkorb passt, je Stand hoechstens 2
   Versuche, keine Schleife). Bis dahin (und wenn beide Versuche scheitern)
   bleiben beide Zeilen leer; liefert Shopify die Section nicht (null),
   ebenfalls - nie veraltet stehen lassen.
   Express: Am Host NIE 'disabled' (wirkt nach dem Rendern nicht und kann die
   Wallets dauerhaft sperren), gesperrt wird per hidden am Container
   (leer, Groessen-Hinweis) bzw. inert am Panel, solange es zugeklappt ist
   oder add/change laeuft (syncExpressUI).
   requires-shipping setzt syncExpress nach cart.requires_shipping (sonst
   bricht Apple/Google Pay nach Landung mit leerem Warenkorb ab). Leerer Host
   (keine Wallets, Fehler) blendet die Gruppe per CSS-:has aus (theme.css). */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var backdrop = drawer.querySelector('.cart-drawer__backdrop');
  var panel    = drawer.querySelector('.cart-drawer__panel');
  var closeBtn = drawer.querySelector('.cart-drawer__close');
  var body     = drawer.querySelector('#cart-drawer-body');
  var itemsEl  = drawer.querySelector('[data-cart-items]');
  var errorEl  = drawer.querySelector('[data-cart-error]');
  var statusEl = drawer.querySelector('[data-cart-status]');
  var upsellsEl = drawer.querySelector('[data-cart-upsells]');

  /* Feste Leiste, Service im Scrollbereich, fester Footer mit Express
     (siehe Kopfkommentar). Express/Service drawer-weit gesucht: je nach
     Markup-Fassung liegen sie im Footer oder in data-cart-extras. Fehlt
     auch footer-main (noch aeltere Fassung), baut renderFooter den Footer
     wie frueher per outerHTML - dann mit den Icons aus dem alten
     data-payment-template. */
  var fsEl        = drawer.querySelector('[data-cart-fs]');
  var extrasEl    = drawer.querySelector('[data-cart-extras]');
  var SPLIT       = !!(fsEl && extrasEl);
  var footerEl    = drawer.querySelector('[data-cart-footer]');
  var footerMain  = footerEl && footerEl.querySelector('[data-cart-footer-main]');
  var expressEl   = drawer.querySelector('[data-cart-express]');
  var expressSlot = expressEl && expressEl.querySelector('[data-cart-express-slot]');
  var expressTpl  = expressEl && expressEl.querySelector('template[data-cart-express-tpl]');
  var expressMounted = false;
  /* Aufklappen (nur neues Markup; ohne Zeile/Panel ist Express offen) */
  var xpToggle    = expressEl && expressEl.querySelector('[data-cart-express-toggle]');
  var xpPanel     = expressEl && expressEl.querySelector('[data-cart-express-panel]');
  var focusEnd    = panel.querySelector('[data-focus-end]');

  /* Aufklapp-Zustand der Express-Zeile: gilt fuer die Sitzung (auch ueber
     Seitenwechsel), sessionStorage kann in privaten Fenstern werfen - dann
     nur fuer diese Seite. Ab 768 px Breite UND 600 px Hoehe ist Express
     immer offen (XP_ROOMY, gleiche Bedingung wie die Media Query im
     Snippet): quer gehaltene Phones sind breit, aber niedrig und behalten
     die Zeile. */
  var XP_KEY = 'paw:cart-express-open';
  var xpFallback = false;
  function readXpOpen() {
    try {
      var v = window.sessionStorage.getItem(XP_KEY);
      return v === null ? xpFallback : v === '1';
    } catch (e) { return xpFallback; }
  }
  function writeXpOpen(on) {
    xpFallback = on;
    try { window.sessionStorage.setItem(XP_KEY, on ? '1' : '0'); } catch (e) { /* egal */ }
  }
  var xpUserOpen = readXpOpen();
  var XP_ROOMY = (typeof window.matchMedia === 'function') ? window.matchMedia('(min-width: 768px) and (min-height: 600px)') : null;

  /* Service-Zeilen (Baustein 2). Cache = zuletzt bekannter Stand der
     Section cart-service; beim Seitenstart aus dem SSR-Markup gelesen,
     BEVOR renderCart neu zeichnet. sig = Warenkorb-Signatur, zu der
     summary/trust gehoeren (siehe cartSig). summaryEl = statischer
     Lieferzeit-Knoten (nur neues Markup; im alten steckt die Zeile in
     footer-main und wird mit ihm neu gebaut). */
  var trustEl   = drawer.querySelector('[data-cart-service="trust"]');
  var summaryEl = SPLIT ? extrasEl.querySelector('[data-cart-service="summary"]') : null;
  /* Graue Service-Flaeche um summary/trust (nur neues Markup) */
  var serviceBoxEl = SPLIT ? extrasEl.querySelector('[data-cart-service-box]') : null;
  var SERVICE = (function () {
    var svc = { summary: '', trust: '', sig: '' };
    try {
      var sum = drawer.querySelector('[data-cart-service="summary"]');
      var sigEl = drawer.querySelector('[data-cart-service-sig]');
      if (sum) svc.summary = sum.innerHTML.trim();
      if (trustEl) svc.trust = trustEl.innerHTML.trim();
      if (sigEl) svc.sig = sigEl.getAttribute('data-cart-service-sig') || '';
    } catch (e) { /* leer lassen, die naechste Aenderung bringt den Stand */ }
    return svc;
  })();
  syncServiceBox();
  var serviceOff = false; /* Section fehlt (null) -> Zeilen aus, kein Nachladen */

  var paymentTpl   = drawer.querySelector('[data-payment-template]');
  var PAYMENT_HTML = paymentTpl ? paymentTpl.innerHTML : '';

  /* Locale-Attribute bereinigt: Fehlt ein Key (z. B. Locale-Datei still
     verworfen), rendert t "translation missing: ..." - das Attribut ist dann
     nicht leer und die Rueckfalltexte unten griffen sonst nie. */
  var L = (function (ds) {
    var o = {};
    for (var k in ds) {
      var v = ds[k];
      o[k] = (typeof v === 'string' && /^\s*translation missing/i.test(v)) ? '' : v;
    }
    return o;
  })(drawer.dataset);
  var STRINGS = {
    empty:            L.localeEmpty            || 'Ihr Warenkorb ist leer.',
    shopDog:          L.localeShopDog          || 'Hund',
    shopCat:          L.localeShopCat          || 'Katze',
    subtotal:         L.localeSubtotal         || 'Zwischensumme',
    checkout:         L.localeCheckout         || 'Zur Kasse',
    remove:           L.localeRemove           || 'Entfernen',
    less:             L.localeLess             || 'Menge verringern',
    more:             L.localeMore             || 'Menge erhoehen',
    error:            L.localeError            || 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut.',
    /* Rueckfalltexte = locales/de.default.json (greifen, falls Shopify
       cart-drawer.liquid still verwirft und nur dieses JS live geht) */
    adding:           L.localeAdding           || 'Wird in den Warenkorb gelegt …',
    added:            L.localeAdded            || 'Zum Warenkorb hinzugefügt',
    errorNetwork:     L.localeErrorNetwork     || 'Keine Verbindung zum Shop. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    errorUnavailable: L.localeErrorUnavailable || 'Dieser Artikel ist leider nicht mehr verfügbar.',
    errorQuantity:    L.localeErrorQuantity    || 'Diese Menge ist leider nicht vorrätig. Bitte wählen Sie eine kleinere Menge.',
    errorUpdate:      L.localeErrorUpdate      || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
    centsUnit:        L.localeCentsUnit        || 'Cent',
    fsRemaining:      L.localeFsRemaining      || 'Noch [amount] bis zum kostenlosen Versand',
    /* mit Versandkosten (W2), nur gesetzt bei Versandkosten > 0 */
    fsRemainingCost:  L.localeFsRemainingCost  || '',
    fsReached:        L.localeFsReached        || 'Kostenloser Versand!',
    fsGift:           L.localeFsGift           || 'Die [amount] gehen auf uns – kostenloser Versand!',
    sizeNoticeTitle:  L.localeSizeNoticeTitle  || '',
    sizeNoticeText:   L.localeSizeNoticeText   || '',
    sizeNoticeLink:   L.localeSizeNoticeLink   || '',
    sizeNoticeHelp:   L.localeSizeNoticeHelp   || '',
    sizeNoticeConfirm:   L.localeSizeNoticeConfirm   || '',
    sizeNoticeConfirmed: L.localeSizeNoticeConfirmed || '',
    sizeNoticeBlocked:   L.localeSizeNoticeBlocked   || '',
    unitPrice:        L.localeUnitPrice        || '([price] / [value] [unit])',
    unitPriceLabel:   L.localeUnitPriceLabel   || ''
  };
  /* Einheiten-Labels fuer den Grundpreis ("ml:ml|m2:m²|item:Stk."),
     Quelle: snippets/unit-price.liquid (mode 'labels'). */
  var UNIT_LABELS = (L.unitLabels || '').split('|').reduce(function (map, pair) {
    var i = pair.indexOf(':');
    if (i > 0) map[pair.slice(0, i)] = pair.slice(i + 1);
    return map;
  }, Object.create(null));
  var ROUTES = {
    hund:  L.routeHund  || '/collections/hund',
    katze: L.routeKatze || '/collections/katze',
    cart:  L.routeCart  || '/cart'
  };
  /* Ziel fuer die persoenliche Groessenberatung (WhatsApp, sonst Kontaktseite). */
  var HELP_URL = L.sizeNoticeHelpUrl || '';
  var FS_THRESHOLD = parseInt(L.fsThreshold, 10) || 10000;
  var FS_TOLERANCE = 100;

  function formatGift(cents) {
    return cents < 100 ? (cents + ' ' + STRINGS.centsUnit) : formatMoney(cents);
  }

  /* withCost: Resttext nennt die Versandkosten (nur die Leiste IM Drawer,
     wie free-shipping-bar.liquid mit with_cost) */
  function fsState(total, threshold, withCost) {
    var effective = Math.max(0, threshold - FS_TOLERANCE);
    var pct = effective > 0 ? Math.min(100, (total / effective) * 100) : 100;
    var complete = total >= effective;
    var msg;
    if (total >= threshold) {
      msg = STRINGS.fsReached;
    } else if (total >= effective) {
      msg = STRINGS.fsGift.replace('[amount]', formatGift(threshold - total));
    } else {
      var remaining = (withCost && STRINGS.fsRemainingCost) ? STRINGS.fsRemainingCost : STRINGS.fsRemaining;
      msg = remaining.replace('[amount]', formatMoney(effective - total));
    }
    return { pct: pct, complete: complete, msg: msg };
  }

  var scrollY       = 0;
  var pendingByKey  = Object.create(null);
  var lastFocused   = null;

  var lastCart      = null; /* zuletzt gezeichneter Stand, auch nach Seitenstart */
  /* cartSeq: beim Absenden vergeben, appliedSeq: zuletzt gezeichnet,
     mutating: laufende add/change (siehe commitCart / refresh) */
  var cartSeq       = 0;
  var appliedSeq    = 0;
  var mutating      = 0;
  var busyCount     = 0; /* laufende/wartende Adds */
  var busyRows      = 0; /* Artikel darin (Skeleton-Zeilen, max. 3) */
  var addChain      = Promise.resolve();
  var REQUEST_TIMEOUT = 20000;
  /* Vorgemerkter Checkout-Klick (siehe submit-Handler); checkoutGen zaehlt
     closeDrawer hoch, damit eine Vormerkung Schliessen + Oeffnen nicht
     ueberlebt. */
  var checkoutQueued = false;
  var checkoutGen    = 0;

  function noop() {}

  function isOpen() {
    return drawer.classList.contains('is-open');
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents) {
    var noDecimals = (cents % 100) === 0;
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: noDecimals ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  /* Grundpreis (PAngV) einer Warenkorb-Zeile - Gegenstueck zu
     snippets/unit-price.liquid (gleiches Format, Bezugsmenge immer
     ausgeschrieben). Ohne unit_price_measurement: leerer String. */
  function buildUnitPriceHTML(item) {
    var m = item.unit_price_measurement;
    if (!m || !m.reference_unit || item.unit_price == null) return '';
    var unitKey = String(m.reference_unit).toLowerCase();
    var unit = UNIT_LABELS[unitKey] || m.reference_unit;
    var value = (m.reference_value != null && m.reference_value !== '') ? m.reference_value : 1;
    var amount = formatMoney(item.unit_price);
    var text = STRINGS.unitPrice
      .replace('[price]', function () { return amount; })
      .replace('[value]', function () { return String(value); })
      .replace('[unit]', function () { return unit; });
    var label = STRINGS.unitPriceLabel
      ? '<span class="visually-hidden">' + escapeHtml(STRINGS.unitPriceLabel) + ' </span>'
      : '';
    return '<p class="unit-price cart-drawer__unit-price">' + label + escapeHtml(text) + '</p>';
  }

  function sizedImage(url, width) {
    if (!url || typeof url !== 'string') return '';
    var isShopifyCdn = url.indexOf('cdn.shopify.com') !== -1 || url.indexOf('/cdn/shop/') !== -1;
    if (!isShopifyCdn) return url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?width=' : '&width=') + width;
  }

  /* Shopify-Inbox-Chat (<shopify-chat>) waehrend des offenen Drawers
     ausblenden. Zusaetzlich zur CSS-Regel in cart-drawer.liquid inline mit
     !important, falls Shopify den Host selbst inline stylt. Der vorherige
     Inline-Wert wird gemerkt und beim Schliessen wiederhergestellt. */
  function setChatHidden(hide) {
    var chats = document.querySelectorAll('shopify-chat');
    for (var i = 0; i < chats.length; i++) {
      var el = chats[i];
      if (hide) {
        if (el.hasAttribute('data-paw-chat-hidden')) continue;
        el.setAttribute('data-paw-chat-hidden', '');
        el.dataset.pawPrevDisplay = el.style.getPropertyValue('display');
        el.dataset.pawPrevPrio = el.style.getPropertyPriority('display');
        el.style.setProperty('display', 'none', 'important');
      } else if (el.hasAttribute('data-paw-chat-hidden')) {
        var prev = el.dataset.pawPrevDisplay || '';
        if (prev) el.style.setProperty('display', prev, el.dataset.pawPrevPrio || '');
        else el.style.removeProperty('display');
        el.removeAttribute('data-paw-chat-hidden');
        delete el.dataset.pawPrevDisplay;
        delete el.dataset.pawPrevPrio;
      }
    }
  }

  function lockScroll() {
    if (document.body.dataset.cartScrollLocked === '1') return;
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top      = '-' + scrollY + 'px';
    document.body.style.left     = '0';
    document.body.style.right    = '0';
    document.body.style.width    = '100%';
    document.body.dataset.cartScrollLocked = '1';
    setChatHidden(true);
  }
  function unlockScroll() {
    if (document.body.dataset.cartScrollLocked !== '1') return;
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.left     = '';
    document.body.style.right    = '';
    document.body.style.width    = '';
    delete document.body.dataset.cartScrollLocked;
    setChatHidden(false);
    window.scrollTo(0, scrollY);
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function getFocusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll(FOCUSABLE),
      /* inert (Ladezustand) ist nicht fokussierbar; der Fokus-Waechter
         zaehlt nicht als Ziel */
      function (el) {
        return el.offsetParent !== null && !el.closest('[inert]') && !el.hasAttribute('data-focus-end');
      }
    );
  }
  /* Vorwaerts-Umbruch macht der Fokus-Waechter am Panelende: Ziele im
     Shadow DOM bzw. im PayPal-iframe stehen nicht in getFocusables() - ein
     Umbruch "nach dem letzten Light-DOM-Ziel" koennte sie ueberspringen.
     Die Wallets sind die letzten Ziele (Footer: Zur Kasse, Zeile
     "Express-Checkout", aufgeklapptes Panel), zugeklappt sind sie inert.
     Rueckwaerts (Shift+Tab vom ersten Ziel): Sind Wallets erreichbar, kommt
     der Fokus auf den Waechter und der native Shift+Tab laeuft weiter - der
     Browser geht von dort einen Schritt zurueck, also auf das letzte Wallet.
     Landet der Fokus dabei ausserhalb des Drawers oder bleibt er auf dem
     Waechter, faengt der Nachlauf ihn auf dem letzten Light-DOM-Ziel.
     Ohne erreichbare Wallets direkt auf das letzte Ziel. */
  var reverseWrap = false;
  function walletsReachable() {
    if (!expressMounted || !expressEl || expressEl.hidden || busyCount > 0 || mutating > 0) return false;
    if (!xpIsOpen() || expressEl.offsetParent === null) return false;
    var host = expressHost();
    return !!host && host.childNodes.length > 0;
  }
  function handleTab(e) {
    if (e.key !== 'Tab') return;
    var list = getFocusables();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0];
    var last  = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      if (focusEnd && walletsReachable()) {
        reverseWrap = true;
        try { focusEnd.focus({ preventScroll: true }); } catch (err) { focusEnd.focus(); }
        setTimeout(function () {
          reverseWrap = false;
          if (!isOpen()) return;
          var a = document.activeElement;
          if (!a || a === focusEnd || !drawer.contains(a)) last.focus();
        }, 0);
        return; /* bewusst kein preventDefault */
      }
      e.preventDefault(); last.focus();
    }
    else if (!e.shiftKey && !focusEnd && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  if (focusEnd) {
    focusEnd.addEventListener('focus', function () {
      if (!isOpen() || reverseWrap) return;
      var list = getFocusables();
      var target = list[0] || closeBtn;
      if (target && target.focus) target.focus();
    });
  }

  /* skipRefresh: ohne /cart.js-Abgleich (Add bringt den Stand mit).
     Event-Objekte (cart:open, Klick-Handler) sind KEINE Optionen. */
  function openDrawer(opts) {
    if (opts && typeof Event !== 'undefined' && opts instanceof Event) opts = null;
    var skipRefresh = !!(opts && opts.skipRefresh === true);
    if (drawer.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    /* Der Scrollbereich ist lang (Artikel, Vorschlaege, Service): jedes
       Oeffnen beginnt bei den Artikeln, nicht dort, wo zuletzt gescrollt
       wurde. Der Aufklapp-Zustand von Express bleibt dagegen erhalten. */
    if (body) body.scrollTop = 0;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    /* Wallets mit dem bekannten Stand einhaengen (erstes Oeffnen), ohne
       auf den /cart.js-Abgleich zu warten */
    syncExpress(lastCart);
    setTimeout(function () {
      if (closeBtn) closeBtn.focus();
    }, 50);
    /* Beim Oeffnen den echten Stand holen: der Drawer ist beim ersten
       Seitenaufruf serverseitig gerendert und weiss nichts von Aenderungen
       aus einem anderen Tab - und der Groessen-Hinweis wird erst hier
       berechnet. Fehler still schlucken, der vorhandene Stand bleibt dann. */
    if (!skipRefresh) refresh().catch(noop);
  }
  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    /* Kunde hat es sich anders ueberlegt: vorgemerkten Checkout verwerfen */
    checkoutGen++;
    checkoutQueued = false;
    unlockScroll();
    clearError();
    announce('');
    if (lastFocused && lastFocused.focus) {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  var ICON_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" fill-rule="evenodd" aria-hidden="true" focusable="false"><path fill="currentColor" d="M3 12a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1"/></svg>';
  var ICON_PLUS  = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" fill-rule="evenodd" aria-hidden="true" focusable="false"><path fill="currentColor" d="M11 20a1 1 0 1 0 2 0v-7h7a1 1 0 1 0 0-2h-7V4a1 1 0 1 0-2 0v7H4a1 1 0 1 0 0 2h7z"/></svg>';

  /* ------------------------------------------------------------------
     Groessen-Hinweis

     Liegt DASSELBE Produkt in zwei verschiedenen GROESSEN im Warenkorb,
     ist das fast immer eine Auswahlbestellung ("welche passt?") - und die
     zweite Groesse kommt als Retoure zurueck. Bei Farbe ist eine Doppel-
     bestellung dagegen oft gewollt, deshalb wird NUR die Groessen-Option
     geprueft. Der Hinweis sperrt den Checkout, bis er bestaetigt wurde -
     bestaetigen kostet einen Klick, eine Retoure kostet uns deutlich mehr.
     ------------------------------------------------------------------ */
  var SIZE_OPTION = /^(gr(ö|oe|o)ss?e|größe|size)$/i;

  function itemSize(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (SIZE_OPTION.test(String(opts[i].name || '').trim())) return String(opts[i].value || '');
    }
    return null;
  }

  /* Liefert { item, signature } fuer das erste Produkt, das in mehreren
     Groessen im Warenkorb liegt. Die Signatur beschreibt die konkrete
     Kombination - aendert sie sich (andere Groesse, anderes Produkt), muss
     erneut bestaetigt werden.

     ⚠️ snippets/cart-size-conflict.liquid baut dieselbe Signatur serverseitig
     auf (fuer den in Liquid gerenderten Checkout-Button und die /cart-Seite).
     Beide teilen sich die Bestaetigung - Aenderungen hier MUESSEN dort
     nachgezogen werden. Deshalb bewusst in Warenkorb-Reihenfolge statt
     sortiert: eine Sortierung faellt in JS und Liquid unterschiedlich aus. */
  function findSizeConflict(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var pid = items[i].product_id;
      if (pid == null) continue;
      var group = items.filter(function (it) { return it.product_id === pid; });
      if (group.length < 2) continue;
      var seen = {}, count = 0, ids = [];
      for (var j = 0; j < group.length; j++) {
        ids.push(group[j].variant_id);
        var size = itemSize(group[j]);
        if (size && !seen[size]) { seen[size] = true; count++; }
      }
      if (count > 1) {
        return { item: group[0], signature: pid + ':' + ids.join('-') };
      }
    }
    return null;
  }

  /* Bestaetigung haelt nur fuer die Sitzung UND nur fuer genau diese
     Kombination - wer spaeter eine dritte Groesse dazulegt, sieht den
     Hinweis erneut. sessionStorage kann in privaten Fenstern werfen. */
  var ACK_KEY = 'paw:size-ack';
  function getAck() {
    try { return window.sessionStorage.getItem(ACK_KEY) || ''; }
    catch (e) { return ackFallback; }
  }
  function setAck(sig) {
    ackFallback = sig;
    try { window.sessionStorage.setItem(ACK_KEY, sig); } catch (e) { /* egal */ }
  }
  var ackFallback = '';

  /* Muss der Hinweis noch bestaetigt werden? Steuert auch den Checkout-Button. */
  function sizeNoticePending(cart) {
    if (!STRINGS.sizeNoticeTitle) return false;
    var c = findSizeConflict(cart);
    return !!c && getAck() !== c.signature;
  }

  function buildSizeNoticeHTML(cart) {
    if (!STRINGS.sizeNoticeTitle) return '';
    var conflict = findSizeConflict(cart);
    if (!conflict) return '';
    var item = conflict.item;
    var done = getAck() === conflict.signature;

    /* ?sizeguide=1 oeffnet die Masstabelle auf der Produktseite direkt.
       item.url traegt oft schon ?variant=... - deshalb den Trenner pruefen. */
    var url  = item.url || '#';
    var sep  = url.indexOf('?') === -1 ? '?' : '&';
    var guideUrl = url + sep + 'sizeguide=1';

    /* Beratung bewusst NICHT ueber den Shopify-Chat: der kennt die
       Groessentabellen (Metafelder) nicht und kann bei genau dieser Frage
       nicht helfen. WhatsApp fuehrt zu einem Menschen, der es kann. */
    var help = HELP_URL
      ? '<a href="' + escapeHtml(HELP_URL) + '" target="_blank" rel="noopener">' + escapeHtml(STRINGS.sizeNoticeHelp) + '</a>'
      : '';

    if (done) {
      return '<div class="cart-drawer__notice is-confirmed" role="note">'
        + '<p class="cart-drawer__notice-text">' + escapeHtml(STRINGS.sizeNoticeConfirmed) + '</p>'
        + '</div>';
    }

    return '<div class="cart-drawer__notice" role="note">'
      + '<p class="cart-drawer__notice-title">' + escapeHtml(STRINGS.sizeNoticeTitle) + '</p>'
      + '<p class="cart-drawer__notice-text">' + escapeHtml(STRINGS.sizeNoticeText) + '</p>'
      + '<div class="cart-drawer__notice-actions">'
      + '<a href="' + escapeHtml(guideUrl) + '">' + escapeHtml(STRINGS.sizeNoticeLink) + '</a>'
      + help
      + '</div>'
      + '<button type="button" class="btn-wipe btn-wipe--compact cart-drawer__notice-confirm"'
      +   ' data-size-ack="' + escapeHtml(conflict.signature) + '">'
      +   escapeHtml(STRINGS.sizeNoticeConfirm)
      + '</button>'
      + '</div>';
  }

  function buildItemsHTML(cart) {
    if (!cart.item_count) {
      return '<div class="cart-drawer__empty">'
        + '<p>' + escapeHtml(STRINGS.empty) + '</p>'
        + '<div class="cart-drawer__empty-ctas">'
        + '<a href="' + escapeHtml(ROUTES.hund) + '" class="btn-wipe btn-wipe-inverse btn-wipe--compact">' + escapeHtml(STRINGS.shopDog) + '</a>'
        + '<a href="' + escapeHtml(ROUTES.katze) + '" class="btn-wipe btn-wipe-inverse btn-wipe--compact">' + escapeHtml(STRINGS.shopCat) + '</a>'
        + '</div>'
        + '</div>';
    }
    var rows = cart.items.map(function (item, i) {
      var line   = i + 1;
      var key    = escapeHtml(item.key || '');
      var url    = escapeHtml(item.url || '#');
      var img1x  = sizedImage(item.image, 160);
      var img2x  = sizedImage(item.image, 320);
      var srcset = (img2x && img2x !== img1x) ? ' srcset="' + escapeHtml(img1x) + ' 1x, ' + escapeHtml(img2x) + ' 2x"' : '';
      var img    = img1x
        ? '<img src="' + escapeHtml(img1x) + '"' + srcset + ' alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy" decoding="async">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';

      return '<li class="cart-drawer__item" data-line="' + line + '" data-line-key="' + key + '">'
        +   '<a href="' + url + '" class="cart-drawer__item-img">' + img + '</a>'
        +   '<div class="cart-drawer__item-info">'
        +     '<a href="' + url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>'
        +     variant
        +     '<div class="cart-drawer__item-row">'
        +       '<div class="cart-drawer__qty">'
        +         '<button type="button" class="cart-drawer__qty-btn" data-action="decrease"' + (item.quantity <= 1 ? ' disabled' : '') + ' aria-label="' + escapeHtml(STRINGS.less) + '">' + ICON_MINUS + '</button>'
        +         '<span class="cart-drawer__qty-value" aria-live="polite">' + item.quantity + '</span>'
        +         '<button type="button" class="cart-drawer__qty-btn" data-action="increase" aria-label="' + escapeHtml(STRINGS.more) + '">' + ICON_PLUS + '</button>'
        +       '</div>'
        +     (item.original_line_price > item.final_line_price
                ? '<span class="cart-drawer__item-price"><s class="cart-drawer__item-price-was">' + formatMoney(item.original_line_price) + '</s> ' + formatMoney(item.final_line_price) + '</span>'
                : '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>')
        +     '</div>'
        +     buildUnitPriceHTML(item)
        +   '</div>'
        +   '<button type="button" class="cart-drawer__remove btn-ghost" data-remove aria-label="' + escapeHtml(STRINGS.remove) + '">'
        +     '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" fill-rule="evenodd" aria-hidden="true"><path fill="currentColor" d="M14.28 2a2 2 0 0 1 1.897 1.368L16.72 5H20a1 1 0 1 1 0 2l-.003.071l-.867 12.143A3 3 0 0 1 16.138 22H7.862a3 3 0 0 1-2.992-2.786L4.003 7.07L4 7a1 1 0 0 1 0-2h3.28l.543-1.632A2 2 0 0 1 9.721 2zm3.717 5H6.003l.862 12.071a1 1 0 0 0 .997.929h8.276a1 1 0 0 0 .997-.929zM10 10a1 1 0 0 1 .993.883L11 11v5a1 1 0 0 1-1.993.117L9 16v-5a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1m.28-6H9.72l-.333 1h5.226z"/></svg>'
        +   '</button>'
        + '</li>';
    }).join('');

    return '<ul class="cart-drawer__items">' + rows + '</ul>';
  }

  function buildFreeShippingHTML(cart) {
    var s = fsState(cart.total_price, FS_THRESHOLD, true);
    return '<div class="free-shipping-bar" data-free-shipping-bar data-threshold="' + FS_THRESHOLD + '">'
      +   '<p class="free-shipping-bar__text">'
      +     '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd" aria-hidden="true"><path d="M12.25 4.299a.5.5 0 0 0-.5 0L6.206 7.5l1.813 1.047l5.798-3.343zm3.568 2.06L10.02 9.702l1.73.999a.5.5 0 0 0 .5 0L17.794 7.5l-1.976-1.14Zm2.976 2.873l-5.544 3.201a2 2 0 0 1-.25.126v6.709l5.544-3.201a.5.5 0 0 0 .25-.433zM11 19.268v-6.709a3 3 0 0 1-.25-.126L5.206 9.232v6.402a.5.5 0 0 0 .25.433zm-.25-16.701a2.5 2.5 0 0 1 2.5 0l6.294 3.634a2.5 2.5 0 0 1 1.25 2.165v7.268a2.5 2.5 0 0 1-1.25 2.165l-6.294 3.634a2.5 2.5 0 0 1-2.5 0l-6.294-3.634a2.5 2.5 0 0 1-1.25-2.165V8.366a2.5 2.5 0 0 1 1.25-2.165z"/></svg>'
      +     '<span data-fs-msg>' + escapeHtml(s.msg) + '</span>'
      +   '</p>'
      +   '<div class="free-shipping-bar__track"><div class="free-shipping-bar__fill' + (s.complete ? ' is-complete' : '') + '" data-fs-fill style="--fs-pct:' + s.pct + '"></div></div>'
      + '</div>';
  }

  /* Nur der veraenderliche Teil des Footers (data-cart-footer-main), ohne
     Wrapper. Neues Markup (SPLIT): nur Zwischensumme + Zur Kasse, Leiste
     und Lieferzeit stehen in eigenen statischen Knoten. Altes Markup:
     beides wie frueher hier. */
  function buildFooterMainHTML(cart) {
    if (!cart.item_count) return '';
    /* Zur Kasse erst nach Bestaetigung des Groessen-Hinweises. */
    var pending = sizeNoticePending(cart);
    return (SPLIT ? '' : buildFreeShippingHTML(cart))
      + '<div class="cart-drawer__subtotal">'
      +   '<span>' + escapeHtml(STRINGS.subtotal) + '</span>'
      +   '<span id="cart-subtotal">' + formatMoney(cart.total_price) + '</span>'
      + '</div>'
      + (SPLIT ? '' : buildServiceSummaryHTML(cart))
      + '<form action="' + escapeHtml(ROUTES.cart) + '" method="post" class="cart-drawer__checkout-form">'
      +   '<button type="submit" name="checkout" class="btn-wipe cart-drawer__checkout"'
      +     (pending ? ' disabled aria-describedby="cart-size-blocked"' : '') + '>'
      +     escapeHtml(STRINGS.checkout)
      +   '</button>'
      +   (pending
        ? '<p class="cart-drawer__checkout-hint" id="cart-size-blocked">' + escapeHtml(STRINGS.sizeNoticeBlocked) + '</p>'
        : '')
      + '</form>';
  }

  /* Gratisversand-Leiste unter dem Kopf: im vorhandenen Knoten nachziehen
     (Fuellstand animiert per transform), nur ohne Leiste neu aufbauen. */
  function syncFs(cart) {
    if (!fsEl) return;
    if (!cart.item_count) { fsEl.hidden = true; return; }
    var fill = fsEl.querySelector('[data-free-shipping-bar] [data-fs-fill]');
    var msg  = fsEl.querySelector('[data-free-shipping-bar] [data-fs-msg]');
    if (fill && msg) {
      var s = fsState(cart.total_price, FS_THRESHOLD, true);
      fill.style.setProperty('--fs-pct', s.pct);
      fill.classList.toggle('is-complete', s.complete);
      if (msg.textContent !== s.msg) msg.textContent = s.msg;
    } else {
      fsEl.innerHTML = buildFreeShippingHTML(cart);
    }
    fsEl.hidden = false;
  }

  /* Footer, Leiste und Kaufoptionen (ohne Express, siehe syncExpress).
     Kaufoptionen VOR syncExpress sichtbar schalten: Wallets duerfen nie in
     einem display:none-Container initialisieren. */
  function renderFooter(cart) {
    if (footerEl && footerMain) {
      footerMain.innerHTML = buildFooterMainHTML(cart);
      footerEl.hidden = !cart.item_count;
      if (SPLIT) {
        extrasEl.hidden = !cart.item_count;
        syncFs(cart);
        syncSummaryNode(cart);
      }
      syncTrust(cart);
      syncServiceBox();
      return;
    }
    /* Rueckfall alte Markup-Version: Footer per outerHTML wie bisher */
    var existing = panel.querySelector('.cart-drawer__footer');
    var html = cart.item_count
      ? '<div class="cart-drawer__footer">' + buildFooterMainHTML(cart)
        + (PAYMENT_HTML ? '<div class="cart-drawer__pay">' + PAYMENT_HTML + '</div>' : '')
        + '</div>'
      : '';
    if (existing) {
      if (html) existing.outerHTML = html;
      else      existing.remove();
    } else if (html) {
      panel.insertAdjacentHTML('beforeend', html);
    }
  }

  /* ------------------------------------------------------------------
     Express-Checkout (Shop Pay, Apple Pay, Google Pay, PayPal)
     Das Markup steht inert im <template>. Eingehaengt wird es EINMAL,
     sobald der Drawer offen ist, der Warenkorb Artikel hat und kein
     Groessen-Hinweis offen ist - erst dann laedt Shopify die Wallet-
     Skripte (Bootstrap-Observer). Danach nur noch hidden umschalten und
     requires-shipping nachziehen, nie neu einsetzen.
     ------------------------------------------------------------------ */
  function expressHost() {
    return expressSlot ? expressSlot.querySelector('shopify-accelerated-checkout-cart') : null;
  }

  /* true/false aus dem Warenkorb, null = unbekannt (dann nichts aendern).
     Fehlt das Gesamtfeld, zaehlen die Positionen (/cart.js und cart|json
     liefern requires_shipping je Zeile). */
  function cartRequiresShipping(cart) {
    if (!cart) return null;
    if (typeof cart.requires_shipping === 'boolean') return cart.requires_shipping;
    var items = Array.isArray(cart.items) ? cart.items : [];
    var known = false;
    for (var i = 0; i < items.length; i++) {
      if (!items[i] || typeof items[i].requires_shipping !== 'boolean') continue;
      if (items[i].requires_shipping) return true;
      known = true;
    }
    return known ? false : null;
  }

  /* requires-shipping beobachtet das Element und reicht es an die Wallets
     weiter (sonst bricht Apple/Google Pay mit digital_physical_mismatch ab,
     wenn die Seite mit leerem Warenkorb geladen wurde). */
  function setShippingAttr(host, cart) {
    var rs = cartRequiresShipping(cart);
    if (!host || rs === null) return;
    if (host.hasAttribute('requires-shipping') === rs) return;
    if (rs) host.setAttribute('requires-shipping', '');
    else    host.removeAttribute('requires-shipping');
  }

  function mountExpress(cart) {
    if (expressMounted || !expressSlot || !expressTpl || !expressTpl.content) return;
    var frag = document.importNode(expressTpl.content, true);
    var host = frag.querySelector('shopify-accelerated-checkout-cart');
    /* Leeres Template (keine Wallets gerendert): nichts einhaengen */
    if (!host) { expressTpl = null; return; }
    setShippingAttr(host, cart);
    /* Container VOR dem Einfuegen sichtbar: Wallets (PayPal-iframe) duerfen
       nie in einem display:none-Container initialisieren. Aufgerufen nur
       bei nicht leerem Warenkorb, Footer (bzw. Kaufoptionen der aelteren
       Fassung) gehoeren dann sichtbar. Ein zugeklapptes Panel ist 0 px
       hoch und inert, aber NICHT display:none - die Wallets rendern dort
       normal und stehen beim Aufklappen fertig bereit. */
    if (extrasEl && extrasEl.contains(expressEl)) extrasEl.hidden = false;
    if (footerEl && footerEl.contains(expressEl)) footerEl.hidden = false;
    expressEl.hidden = false;
    syncExpressUI();
    expressSlot.appendChild(frag);
    expressMounted = true;
    if (expressTpl.parentNode) expressTpl.parentNode.removeChild(expressTpl);
    expressTpl = null;
  }

  /* Offen: ab 768 x 600 px immer, sonst nach Wahl des Kunden (Zeile). Ohne
     Zeile/Panel (aeltere Markup-Fassung) ist Express immer offen. */
  function xpIsOpen() {
    return !xpToggle || !xpPanel || !!(XP_ROOMY && XP_ROOMY.matches) || xpUserOpen;
  }

  /* Zustand an Zeile und Panel: Klasse is-xp-open (CSS: Hoehe, Einblenden,
     Chevron), aria-expanded, aria-hidden und inert. inert auch offen,
     solange add/change laeuft - symmetrisch zur Formular-Sperre im
     submit-Handler: Das Express-Element holt den Warenkorb beim Klick
     selbst (Storefront-API), mitten in einer Mengen-Aenderung saehe das
     Sheet sonst die alte Menge. Nur inert (nie disabled am Host), inert
     laedt den PayPal-iframe nicht neu. Ohne Panel (aeltere Fassung) wie
     frueher inert am ganzen Express-Block. */
  function syncExpressUI() {
    if (!expressEl) return;
    if (!xpPanel) { setInert(expressEl, mutating > 0); return; }
    var open = xpIsOpen();
    expressEl.classList.toggle('is-xp-open', open);
    if (xpToggle) xpToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) xpPanel.removeAttribute('aria-hidden');
    else      xpPanel.setAttribute('aria-hidden', 'true');
    /* Fokus in einem zuklappenden Panel (z. B. Drehen ins Hochformat):
       auf die Zeile, sonst fiele er mit inert auf den body */
    if (!open && xpToggle) {
      var a = document.activeElement;
      if (a && a !== xpPanel && xpPanel.contains(a)) {
        try { xpToggle.focus({ preventScroll: true }); } catch (e) { xpToggle.focus(); }
      }
    }
    setInert(xpPanel, !open || mutating > 0);
  }

  /* Zeile angetippt. Laeuft der Footer auf sehr niedrigen Bildschirmen
     ueber (max-height), die aufgeklappten Wallets in seinen Sichtbereich
     holen. */
  function toggleExpress() {
    xpUserOpen = !xpIsOpen();
    writeXpOpen(xpUserOpen);
    syncExpressUI();
    if (xpUserOpen && footerEl && footerEl.scrollHeight > footerEl.clientHeight + 1) {
      footerEl.scrollTop = footerEl.scrollHeight;
    }
  }

  function syncExpress(cart) {
    if (!expressEl) return;
    try {
      var allowed = !!cart && cart.item_count > 0 && !sizeNoticePending(cart);
      if (allowed && !expressMounted && isOpen()) mountExpress(cart);
      if (expressMounted) setShippingAttr(expressHost(), cart);
      expressEl.hidden = !(allowed && expressMounted);
    } catch (e) {
      expressEl.hidden = true;
    }
  }

  /* Bundled Section Rendering (max. 5 je Request): add.js liefert nur die
     Artikel, den Warenkorb bringt die Section cart-state (nirgends
     eingebunden) mit; change.js liefert den Warenkorb selbst. */
  var UPSELLS_SECTION = 'cart-upsells';
  var STATE_SECTION   = 'cart-state';
  var SERVICE_SECTION = 'cart-service';
  /* add.js: 3 von max. 5, change.js: 2 */
  var SECTIONS        = UPSELLS_SECTION + ',' + STATE_SECTION + ',' + SERVICE_SECTION;
  var CHANGE_SECTIONS = UPSELLS_SECTION + ',' + SERVICE_SECTION;

  function setUpsellsHTML(html) {
    if (!upsellsEl) return;
    upsellsEl.innerHTML = (html && html.trim()) ? html : '';
  }

  /* null = nicht gerendert -> Inhalt bleibt (Upsells). cart-service null
     -> Service-Zeilen aus (veraltete Lieferzeit/Widerruf waeren schlimmer
     als keine). Gezeichnet wird danach von renderCart. */
  function applySections(sections) {
    if (!sections) return;
    var html = sections[UPSELLS_SECTION];
    if (upsellsEl && html != null) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var content = tmp.querySelector('[data-cart-upsells-content]');
      setUpsellsHTML(content ? content.innerHTML : '');
    }
    if (Object.prototype.hasOwnProperty.call(sections, SERVICE_SECTION)) {
      var svc = parseService(sections[SERVICE_SECTION]);
      if (svc) SERVICE = svc;
      else disableService();
    }
  }

  /* ------------------------------------------------------------------
     Service-Zeilen (Section cart-service)
     ------------------------------------------------------------------ */

  /* Identisch zu snippets/cart-service.liquid part 'sig' */
  function cartSig(c) {
    if (!c || !Array.isArray(c.items)) return '';
    return c.total_price + '#' + c.items.map(function (it) {
      return it.key + ':' + it.quantity;
    }).join('|');
  }

  /* Antwort-HTML -> { summary, trust, sig } oder null. Ueber <template>:
     Bilder/Skripte darin laden nicht. innerHTML liefert die vom Browser
     normalisierte Form - so ist der Vergleich in setInner stabil. */
  function parseService(html) {
    if (typeof html !== 'string') return null;
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var root = (tpl.content || tpl).querySelector('[data-cart-service-content]');
    if (!root) return null;
    var sum = root.querySelector('[data-part="summary"]');
    var tr  = root.querySelector('[data-part="trust"]');
    return {
      summary: sum ? sum.innerHTML.trim() : '',
      trust:   tr ? tr.innerHTML.trim() : '',
      sig:     root.getAttribute('data-cart-sig') || ''
    };
  }

  function disableService() {
    serviceOff = true;
    SERVICE = { summary: '', trust: '', sig: '' };
  }

  /* Zeilen NUR zum passenden Warenkorb: gehoert der Cache zu einem anderen
     Stand (anderer Tab, ueberlappende Requests), bleibt die Zeile leer, bis
     der GET in ensureServiceFresh den passenden Stand bringt. Scheitert der,
     bleibt sie leer - nie die Lieferzeit/den Widerruf eines fremden Stands
     zeigen (z. B. ohne FLUM-Ausnahme). */
  function serviceFor(cart, part) {
    if (!cart || !cart.item_count || !SERVICE.sig || SERVICE.sig !== cartSig(cart)) return '';
    return SERVICE[part] || '';
  }

  function buildServiceSummaryHTML(cart) {
    var html = serviceFor(cart, 'summary');
    if (!html) return '';
    return '<div class="cart-drawer__service" data-cart-service="summary">' + html + '</div>';
  }

  /* Nur den Inhalt EINES Knotens tauschen und nur bei Aenderung (Fokus auf
     dem Widerrufs-Link bleibt erhalten, Express-Slot wird nie beruehrt). */
  function setInner(el, html) {
    if (el && el.innerHTML.trim() !== html) el.innerHTML = html;
  }

  function syncTrust(cart) {
    setInner(trustEl, serviceFor(cart, 'trust'));
  }

  /* Sind summary und trust leer (Stand laedt, Section null), die ganze
     Flaeche per hidden ausblenden - nicht nur per CSS-:has, das aeltere
     Browser (Safari < 15.4, Firefox < 121) verwerfen; dort bliebe sonst
     eine leere graue Flaeche stehen. Nach jedem syncSummaryNode/syncTrust. */
  function syncServiceBox() {
    if (!serviceBoxEl) return;
    var filled = (summaryEl && summaryEl.innerHTML.trim())
      || (trustEl && serviceBoxEl.contains(trustEl) && trustEl.innerHTML.trim());
    serviceBoxEl.hidden = !filled;
  }

  /* Lieferzeit nachziehen. Neues Markup: Inhalt des statischen Knotens
     tauschen. Altes Markup (nach einem GET): Zeile in footer-main
     einsetzen/aktualisieren, ohne footer-main neu zu bauen (Fokus auf
     "Zur Kasse" bleibt). */
  function syncSummaryNode(cart) {
    if (summaryEl) { setInner(summaryEl, serviceFor(cart, 'summary')); return; }
    if (!footerMain) return;
    var html = serviceFor(cart, 'summary');
    var el = footerMain.querySelector('[data-cart-service="summary"]');
    if (!html) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      return;
    }
    if (el) { setInner(el, html); return; }
    var sub = footerMain.querySelector('.cart-drawer__subtotal');
    if (sub) sub.insertAdjacentHTML('afterend', buildServiceSummaryHTML(cart));
  }

  /* Warenkorb anderswo geaendert (anderer Tab, refresh, Seitenstart mit
     anderem Stand): Section einmal per GET nachholen. Uebernommen wird nur
     eine Antwort, die zum zuletzt gezeichneten Warenkorb passt. Je Stand
     hoechstens 2 Versuche, immer nur einer gleichzeitig - keine Schleife. */
  var svcFetch = { sig: '', tries: 0, busy: false };
  function ensureServiceFresh(cart) {
    if (serviceOff || !cart || !cart.item_count) return;
    var want = cartSig(cart);
    if (!want || want === SERVICE.sig || svcFetch.busy) return;
    if (svcFetch.sig !== want) { svcFetch.sig = want; svcFetch.tries = 0; }
    if (svcFetch.tries >= 2) return;
    svcFetch.tries++;
    svcFetch.busy = true;
    var url = ROUTES.cart + (ROUTES.cart.indexOf('?') === -1 ? '?' : '&') + 'sections=' + SERVICE_SECTION;
    requestJSON(url, { headers: { 'Accept': 'application/json' } }, { op: 'read', qty: 0 })
      .then(function (data) {
        if (!data || !Object.prototype.hasOwnProperty.call(data, SERVICE_SECTION)) return;
        var svc = parseService(data[SERVICE_SECTION]);
        if (!svc) {
          disableService();
        } else if (lastCart && svc.sig === cartSig(lastCart)) {
          SERVICE = svc;
        } else {
          return;
        }
        syncSummaryNode(lastCart);
        syncTrust(lastCart);
        syncServiceBox();
      })
      .catch(noop)
      .then(function () {
        svcFetch.busy = false;
        ensureServiceFresh(lastCart);
      });
  }

  function isCart(c) {
    if (!c || typeof c !== 'object' || !Array.isArray(c.items)) return false;
    if (typeof c.item_count !== 'number' || typeof c.total_price !== 'number') return false;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (!it || typeof it.key !== 'string' || typeof it.quantity !== 'number'
        || typeof it.final_line_price !== 'number') return false;
    }
    return true;
  }

  /* Per String statt HTML-Parser (ein "</script>" in Properties beendet so
     nichts). null/unvollstaendig -> null, Aufrufer nimmt /cart.js. */
  function cartFromSections(sections) {
    var html = sections && sections[STATE_SECTION];
    if (typeof html !== 'string') return null;
    var at    = html.indexOf('data-cart-state');
    var start = at === -1 ? -1 : html.indexOf('>', at);
    var end   = html.lastIndexOf('</script>');
    if (start === -1 || end <= start) return null;
    var cart;
    try { cart = JSON.parse(html.slice(start + 1, end)); } catch (e) { return null; }
    if (!isCart(cart)) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!Array.isArray(it.options_with_values) || typeof it.url !== 'string'
        || it.product_id == null || it.variant_id == null) return null;
    }
    return cart;
  }

  function extend(a, b) {
    var o = {}, k;
    for (k in a) if (Object.prototype.hasOwnProperty.call(a, k)) o[k] = a[k];
    for (k in b) if (Object.prototype.hasOwnProperty.call(b, k)) o[k] = b[k];
    return o;
  }

  /* Fehler -> Kundentext (W16), nie Rohtexte wie "Failed to fetch". */
  function userMessage(err) {
    if (!err) return STRINGS.error;
    if (typeof err.userMessage === 'string' && err.userMessage) return err.userMessage;
    if (err.kind === 'network') return STRINGS.errorNetwork;
    if (err.kind === 'http') {
      if (err.status === 404 || /cannot find variant/i.test(err.description || '')) return STRINGS.errorUnavailable;
      if (err.status === 422) {
        /* Shopifys Text, lokalisiert ueber die Sprach-Route */
        if (err.description && err.description.length <= 300) return err.description;
        return (err.op === 'change' || err.qty > 1) ? STRINGS.errorQuantity : STRINGS.errorUnavailable;
      }
    }
    /* Menge/Entfernen: nicht "konnte nicht hinzugefuegt werden" */
    return err.op === 'change' ? STRINGS.errorUpdate : STRINGS.error;
  }

  /* kind: http | network (inkl. Timeout) | parse | input | unknown */
  function cartError(kind, status, data, ctx, cause) {
    var e = new Error(kind);
    e.kind = kind;
    e.status = status || 0;
    e.code = e.status;
    e.description = (data && typeof data.description === 'string') ? data.description.trim() : '';
    e.op  = ctx ? ctx.op : '';
    e.qty = ctx ? ctx.qty : 0;
    if (cause) e.cause = cause;
    e.userMessage = userMessage(e);
    e.message = e.userMessage;
    return e;
  }

  function toUserError(err, ctx) {
    if (err && typeof err.userMessage === 'string' && err.userMessage && err.message === err.userMessage) return err;
    return cartError((err && err.kind) || 'unknown', err && err.status, null, ctx || null, err);
  }

  /* Eigenes JSON.parse + Timeout (ein haengender Request sperrte sonst
     Add-Kette und Checkout). */
  function requestJSON(url, init, ctx) {
    init = init || {};
    var ctrl  = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = 0;
    if (ctrl) {
      init.signal = ctrl.signal;
      timer = setTimeout(function () { ctrl.abort(); }, REQUEST_TIMEOUT);
    }
    return fetch(url, init).then(function (r) {
      return r.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
        if (!r.ok) throw cartError('http', r.status, data, ctx);
        if (!data || typeof data !== 'object') throw cartError('parse', r.status, null, ctx);
        return data;
      }, function (e) {
        throw cartError('network', 0, null, ctx, e);
      });
    }, function (e) {
      throw cartError('network', 0, null, ctx, e);
    }).then(function (data) {
      clearTimeout(timer);
      return data;
    }, function (e) {
      clearTimeout(timer);
      throw e;
    });
  }

  /* Sprachbewusste Ajax-URL (/en/: Titel, item.url und Fehlertexte in der
     Shop-Sprache). Shopify.routes.root endet immer auf "/". */
  function cartRoute(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function fetchCart() {
    return requestJSON(cartRoute('cart.js'), { headers: { 'Accept': 'application/json' } }, { op: 'read', qty: 0 });
  }

  /* Zeichnet nur, wenn nicht aelter als der zuletzt gezeichnete Stand. */
  function commitCart(cart, seq, sections) {
    if (!isCart(cart) || seq <= appliedSeq) return false;
    appliedSeq = seq;
    lastCart = cart;
    applySections(sections);
    renderCart(cart);
    return true;
  }

  /* Liefen add/change gleichzeitig (Add neben Mengen-Aenderung, Changes
     auf verschiedene Keys), kann der Server sie anders herum verarbeitet
     haben als abgeschickt. Dann ist keine Antwort sicher der neueste Stand
     (die frischeste wird evtl. sogar als "aelter" verworfen) -> nach der
     letzten Antwort einmal per refresh() abgleichen. */
  var overlapped  = false;
  var idleWaiters = [];

  /* resolved, sobald kein add/change mehr laeuft */
  function whenIdle() {
    if (mutating === 0) return Promise.resolve();
    return new Promise(function (resolve) { idleWaiters.push(resolve); });
  }

  /* Wallets sind gesperrt, solange add/change laeuft (syncExpressUI) */
  function mutate(run) {
    var ended = false;
    function end() {
      if (ended) return;
      ended = true;
      mutating--;
      syncExpressUI();
      if (mutating > 0) return;
      if (overlapped) {
        overlapped = false;
        refresh().catch(noop);
      }
      var waiters = idleWaiters;
      idleWaiters = [];
      for (var i = 0; i < waiters.length; i++) waiters[i]();
    }
    if (mutating > 0) overlapped = true;
    mutating++;
    syncExpressUI();
    var p;
    try { p = Promise.resolve(run()); } catch (e) { end(); return Promise.reject(e); }
    return p.then(function (v) { end(); return v; }, function (e) { end(); throw e; });
  }

  /* Lese-Abruf: lief beim Absenden oder laeuft bei der Antwort ein
     add/change, ist der Stand evtl. ueberholt - dann zeichnet dessen
     Antwort (bzw. Rollback). Das Promise liefert den Warenkorb trotzdem. */
  function refresh() {
    var seq = ++cartSeq;
    var tainted = mutating > 0;
    return fetchCart().then(function (cart) {
      if (!tainted && mutating === 0) commitCart(cart, seq);
      return cart;
    });
  }

  /* Rollback nach einem Fehler: echten Stand holen. Scheitert auch das
     (offline, Timeout), den zuletzt gezeichneten gueltigen Stand neu
     zeichnen - sonst blieben gesperrte Zeilen (is-loading) und die
     optimistisch gesetzte Menge stehen. Laeuft inzwischen wieder ein
     add/change, zeichnet dessen Antwort (bzw. dessen Rollback). */
  function rollback() {
    return refresh().then(function (cart) {
      if (!isCart(cart)) restoreLast();
    }, function () {
      restoreLast();
    });
  }

  function restoreLast() {
    if (mutating > 0) return;
    if (lastCart) {
      try { renderCart(lastCart); return; } catch (e) { /* unten entsperren */ }
    }
    /* Noch nie ein Stand geladen (Abgleich beim Seitenstart gescheitert):
       wenigstens die Zeilen entsperren und die alte Menge zeigen */
    if (!itemsEl) return;
    var rows = itemsEl.querySelectorAll('[data-line].is-loading');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      row.classList.remove('is-loading');
      var q = row.querySelector('.cart-drawer__qty-value');
      if (q && row.getAttribute('data-qty-was')) q.textContent = row.getAttribute('data-qty-was');
      row.removeAttribute('data-qty-was');
    }
  }

  /* Ladezustand (W10): Skeleton, Fortschrittslinie (CSS), role=status */
  var SKELETON_ROW = '<li class="cart-drawer__item cart-drawer__item--skeleton" data-cart-skeleton aria-hidden="true">'
    +   '<span class="cart-drawer__skeleton-img"></span>'
    +   '<span class="cart-drawer__skeleton-lines">'
    +     '<span class="cart-drawer__skeleton-line"></span>'
    +     '<span class="cart-drawer__skeleton-line cart-drawer__skeleton-line--short"></span>'
    +   '</span>'
    + '</li>';

  /* Oben in der Liste (leerer Warenkorb: eigene Liste); nach jedem
     renderCart neu abgleichen. */
  function syncSkeletons() {
    if (!itemsEl) return;
    var old = itemsEl.querySelectorAll('[data-cart-skeleton], [data-cart-skeleton-list]');
    for (var i = 0; i < old.length; i++) old[i].remove();
    var rows = busyCount > 0 ? Math.min(Math.max(busyRows, 1), 3) : 0;
    if (!rows) return;
    var list = itemsEl.querySelector('.cart-drawer__items');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'cart-drawer__items';
      list.setAttribute('data-cart-skeleton-list', '');
      list.setAttribute('aria-hidden', 'true');
      itemsEl.insertBefore(list, itemsEl.firstChild);
    }
    var html = '';
    for (var r = 0; r < rows; r++) html += SKELETON_ROW;
    list.insertAdjacentHTML('afterbegin', html);
  }

  function setInert(el, on) {
    if (!el) return;
    if (on) el.setAttribute('inert', '');
    else    el.removeAttribute('inert');
  }

  /* aria-busy nur am Body (am Panel hielte er die Status-Ansage zurueck);
     inert sperrt auch die Tastatur (Zur Kasse). */
  function syncBusy() {
    var on = busyCount > 0;
    drawer.classList.toggle('is-busy', on);
    if (body) {
      if (on) body.setAttribute('aria-busy', 'true');
      else    body.removeAttribute('aria-busy');
    }
    setInert(body, on);
    setInert(panel.querySelector('.cart-drawer__footer'), on);
    syncSkeletons();
  }

  function setBusy(on, rows) {
    var n = Math.max(1, rows || 1);
    if (on) {
      /* Fokus aus kuenftig inerten Bereichen holen (z. B. Upsell-Plus) */
      var active = document.activeElement;
      if (isOpen() && closeBtn && active && active !== closeBtn && active.closest
        && ((body && body.contains(active)) || active.closest('.cart-drawer__footer'))) {
        try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
      }
      busyCount++;
      busyRows += n;
    } else {
      busyCount = Math.max(0, busyCount - 1);
      busyRows  = Math.max(0, busyRows - n);
    }
    syncBusy();
  }

  var announceT = 0;
  function announce(text) {
    if (!statusEl) return;
    clearTimeout(announceT);
    statusEl.textContent = '';
    if (!text) return;
    /* Tick warten: frisch eingeblendete Live-Regionen werden sonst verschluckt */
    announceT = setTimeout(function () { statusEl.textContent = text; }, 200);
  }

  /* sticky: bleibt bis zum Schliessen oder naechsten Versuch */
  function showError(message, opts) {
    if (!errorEl) return;
    errorEl.textContent = message || STRINGS.error;
    errorEl.classList.add('is-visible');
    clearTimeout(showError._t);
    if (opts && opts.sticky) return;
    showError._t = setTimeout(function () {
      errorEl.classList.remove('is-visible');
    }, 5000);
  }
  function clearError() {
    if (!errorEl) return;
    errorEl.classList.remove('is-visible');
    clearTimeout(showError._t);
  }

  var lastExternalCartTotal = 0;
  function updateExternalFsBars(totalPriceCents) {
    lastExternalCartTotal = totalPriceCents;
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    Array.prototype.forEach.call(bars, function (bar) {
      if (drawer.contains(bar)) return;
      var threshold = parseInt(bar.dataset.threshold, 10) || FS_THRESHOLD;
      var extra = parseInt(bar.dataset.fsExtra, 10) || 0;
      var s = fsState(totalPriceCents + extra, threshold);
      var fill = bar.querySelector('[data-fs-fill]');
      var msg  = bar.querySelector('[data-fs-msg]');
      if (fill) {
        fill.style.setProperty('--fs-pct', s.pct);
        fill.classList.toggle('is-complete', s.complete);
      }
      if (msg) {
        msg.textContent = s.msg;
      }
    });
  }

  function updateCartCount(count) {
    var el = document.getElementById('cart-count');
    if (el) el.textContent = count > 0 ? String(count) : '';
  }

  function renderCart(cart) {
    if (itemsEl) itemsEl.innerHTML = buildItemsHTML(cart);

    var noticeEl = panel.querySelector('[data-cart-size-notice]');
    if (noticeEl) noticeEl.innerHTML = buildSizeNoticeHTML(cart);

    renderFooter(cart);
    syncExpress(cart);
    ensureServiceFresh(cart);

    /* laeuft noch ein Add: Skeleton + inert auf die neuen Knoten */
    syncBusy();

    updateCartCount(cart.item_count);
    updateExternalFsBars(cart.total_price);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  /* Hinzufuegen (W10/W16): EIN Request (add.js + cart-upsells,cart-state),
     Kundentexte bei Fehlern, refresh() als Rollback, Adds nacheinander. */
  function postAdd(payload, detail, opts) {
    var open = !(opts && opts.open === false);
    var rows = payload.items ? payload.items.length : 1;
    var qty  = payload.items
      ? payload.items.reduce(function (m, it) { return Math.max(m, it.quantity); }, 1)
      : payload.quantity;
    var ctx  = { op: 'add', qty: qty };

    var request = { sections: SECTIONS, sections_url: location.pathname };
    if (payload.items) {
      request.items = payload.items;
    } else {
      request.id = payload.id;
      request.quantity = payload.quantity;
    }

    /* Rueckmeldung sofort, auch wenn der Request noch wartet */
    clearError();
    setBusy(true, rows);
    if (open) openDrawer({ skipRefresh: true });
    if (isOpen()) announce(STRINGS.adding);

    var released = false;
    function release() {
      if (released) return;
      released = true;
      setBusy(false, rows);
    }

    function task() {
      var seq = ++cartSeq;
      var sections = null;
      var added = null;
      return mutate(function () {
        return requestJSON(cartRoute('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(request)
        }, ctx).then(function (data) {
          sections = data.sections || null;
          delete data.sections;
          added = data;
          /* Rueckfall /cart.js, wenn cart-state fehlt. Scheitert auch der,
             liegt der Artikel trotzdem im Warenkorb: KEIN Fehler melden,
             sonst klickt der Kunde erneut und legt ihn doppelt hinein. */
          return cartFromSections(sections) || fetchCart().catch(function () { return null; });
        });
      }).then(function (cart) {
        try {
          if (cart) {
            commitCart(cart, seq, sections);
          } else {
            /* Stand nachholen, sobald das Netz wieder da ist */
            applySections(sections);
            refresh().catch(noop);
          }
        } catch (renderErr) {
          /* Artikel liegt im Warenkorb, nur das Zeichnen schlug fehl */
          refresh().catch(noop);
        }
        release();
        if (isOpen()) announce(STRINGS.added);
        document.dispatchEvent(new CustomEvent('cart:add:success', {
          detail: extend(detail, { cart: cart || null, opened: open })
        }));
        return cart || added;
      }, function (err) {
        var e = toUserError(err, ctx);
        release();
        /* nur im OFFENEN Drawer, sonst zeigt ihn der Aufrufer */
        var shown = isOpen();
        if (shown) {
          announce('');
          showError(e.userMessage, { sticky: true });
        }
        e.shownInDrawer = shown;
        /* Rollback auf den echten Stand (auch Teil-Adds bei addMulti),
           offline auf den zuletzt gezeichneten */
        rollback();
        document.dispatchEvent(new CustomEvent('cart:add:error', {
          detail: extend(detail, { error: e.userMessage, status: e.status, opened: open, shown: shown })
        }));
        throw e;
      });
    }

    var p = addChain.then(task);
    addChain = p.catch(noop);
    return p;
  }

  function addItem(variantId, quantity, opts) {
    var qty = parseInt(quantity, 10) || 1;
    var id  = parseInt(variantId, 10);
    if (!id) return Promise.reject(cartError('input', 0, null, { op: 'add', qty: qty }));
    return postAdd({ id: id, quantity: qty }, { variantId: id }, opts);
  }

  function addItems(items, opts) {
    var clean = (Array.isArray(items) ? items : [])
      .map(function (it) {
        var raw = (it && it.id != null) ? it.id : it;
        return { id: parseInt(raw, 10), quantity: parseInt(it && it.quantity, 10) || 1 };
      })
      .filter(function (it) { return it.id; });
    if (!clean.length) return Promise.reject(cartError('input', 0, null, { op: 'add', qty: 1 }));
    return postAdd({ items: clean }, { items: clean }, opts);
  }

  function changeByKey(key, quantity) {
    clearError();
    var ctx = { op: 'change', qty: quantity };
    if (!key) return Promise.reject(cartError('input', 0, null, ctx));
    var k = String(key);
    var prev = pendingByKey[k] || Promise.resolve();
    var next = prev.then(function () {
      var seq = ++cartSeq;
      return mutate(function () {
        return requestJSON(cartRoute('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: k, quantity: quantity, sections: CHANGE_SECTIONS, sections_url: location.pathname })
        }, ctx);
      }).then(function (cart) {
        var sections = cart.sections || null;
        delete cart.sections;
        try {
          commitCart(cart, seq, sections);
        } catch (renderErr) {
          /* Aenderung ist durch, nur das Zeichnen schlug fehl */
          refresh().catch(noop);
        }
        return cart;
      });
    }).catch(function (err) {
      var e = toUserError(err, ctx);
      e.shownInDrawer = isOpen();
      /* Netzfehler bleiben stehen (bis Schliessen oder naechster Versuch):
         der Drawer zeigt dann nur den zuletzt bekannten Stand */
      if (e.shownInDrawer) showError(e.userMessage, { sticky: e.kind === 'network' });
      rollback();
      throw e;
    }).finally(function () {
      if (pendingByKey[k] === next) delete pendingByKey[k];
    });
    pendingByKey[k] = next;
    return next;
  }

  window.Cart = {
    add:      function (variantId, quantity, opts) { return addItem(variantId, quantity, opts); },
    addMulti: function (items, opts) { return addItems(items, opts); },
    change:   changeByKey,
    remove:   function (key) { return changeByKey(key, 0); },
    refresh:  refresh,
    open:     function (opts) { openDrawer(opts); },
    close:    function () { closeDrawer(); },
    userMessage: userMessage,
    updateFsBars: function () { updateExternalFsBars(lastExternalCartTotal); }
  };

  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (backdrop)  backdrop.addEventListener('click', closeDrawer);

  /* Liegt der Fokus ausserhalb des Drawers (Fehler-/Hinweisdialog der
     Wallets am body, Inbox-Chat, Klaviyo-Flyout), gehoeren ESC und Tab
     diesem Element: ESC schliesst dann nur dessen Dialog, nicht zusaetzlich
     den Drawer darunter. Bewusste Entscheidung, siehe Abnahme Batch 2 (d). */
  function focusOutsideDrawer() {
    var a = document.activeElement;
    return !!a && a !== document.body && a !== document.documentElement && !drawer.contains(a);
  }

  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (focusOutsideDrawer()) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); }
    else handleTab(e);
  });

  /* Kein Checkout, solange sich der Warenkorb noch aendert.
     - Add laeuft: Footer ist inert, hier die Sperre fuer Browser ohne inert.
     - Menge/Entfernen laeuft: der Formular-POST konkurrierte mit change.js
       (die Kasse saehe evtl. die alte Menge). Den Klick nicht verlieren,
       sondern nach der letzten Antwort ausfuehren - ausser der Drawer ist
       zu, zeigt einen Fehler oder der Button ist danach gesperrt (leerer
       Warenkorb, Groessen-Hinweis). */
  drawer.addEventListener('submit', function (e) {
    if (busyCount > 0) { e.preventDefault(); return; }
    if (mutating === 0) return;
    var form = e.target;
    if (!form || !form.closest || !form.closest('.cart-drawer__checkout-form')) return;
    e.preventDefault();
    if (checkoutQueued) return;
    checkoutQueued = true;
    var gen = checkoutGen;
    whenIdle().then(function () {
      /* einen Tick warten: erst zeichnet die letzte Antwort */
      setTimeout(function () {
        /* Drawer inzwischen geschlossen (auch wenn wieder offen): verworfen */
        if (gen !== checkoutGen) return;
        checkoutQueued = false;
        if (!isOpen() || busyCount > 0) return;
        if (errorEl && errorEl.classList.contains('is-visible')) return;
        var btn = panel.querySelector('.cart-drawer__checkout');
        if (btn && !btn.disabled) btn.click();
      }, 0);
    });
  });

  /* ------------------------------------------------------------------
     Nach einem Vorschlag-Add (Pruefung 15.10.2026): Die Karte verschwindet
     (cart-upsells-list blendet Warenkorb-Produkte aus), die neue Zeile
     steht oben bei den Artikeln, bei mehreren Artikeln evtl. ausserhalb des
     Sichtbereichs. setBusy hat den Fokus derweil auf "Schliessen" gerettet.
     ------------------------------------------------------------------ */
  function upsellControls() {
    return upsellsEl ? Array.prototype.slice.call(upsellsEl.querySelectorAll('.cart-upsell__add')) : [];
  }

  function lineKeys() {
    var keys = {};
    if (!itemsEl) return keys;
    var rows = itemsEl.querySelectorAll('[data-line-key]');
    for (var i = 0; i < rows.length; i++) keys[rows[i].getAttribute('data-line-key')] = true;
    return keys;
  }

  /* Element im Scrollbereich zeigen, nur wenn noetig (wie block:nearest).
     Bewusst ohne scrollIntoView: das scrollt auch Vorfahren (Seite unter
     dem Scroll-Lock, iOS-Visual-Viewport). Smooth nur ohne reduced motion. */
  function revealInBody(el, smooth) {
    if (!body || !el || !body.contains(el)) return;
    var br = body.getBoundingClientRect();
    var er = el.getBoundingClientRect();
    var cs = window.getComputedStyle(body);
    var padTop = parseFloat(cs.paddingTop) || 0;
    var padBottom = parseFloat(cs.paddingBottom) || 0;
    var delta = 0;
    if (er.top < br.top + padTop) {
      delta = er.top - br.top - padTop;
    } else if (er.bottom > br.bottom - padBottom) {
      delta = Math.min(er.bottom - br.bottom + padBottom, er.top - br.top - padTop);
    }
    if (Math.abs(delta) < 1) return;
    var top = Math.max(0, body.scrollTop + delta);
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (smooth && !reduce && typeof body.scrollTo === 'function') {
      try { body.scrollTo({ top: top, behavior: 'smooth' }); return; } catch (err) { /* unten sofort */ }
    }
    body.scrollTop = top;
  }

  /* Zeiger/Touch: die neue Zeile als sichtbare Bestaetigung zeigen. Neu =
     Key, den es vorher nicht gab; sonst die Zeile der Variante (Key
     beginnt mit der Varianten-ID). */
  function revealNewLine(keysBefore, variantId) {
    if (!isOpen() || !itemsEl) return;
    var rows = itemsEl.querySelectorAll('[data-line-key]');
    var row = null;
    var i;
    for (i = 0; i < rows.length && !row; i++) {
      if (!keysBefore[rows[i].getAttribute('data-line-key')]) row = rows[i];
    }
    for (i = 0; i < rows.length && !row; i++) {
      if ((rows[i].getAttribute('data-line-key') || '').indexOf(String(variantId) + ':') === 0) row = rows[i];
    }
    if (row) revealInBody(row, true);
  }

  /* Fokus zurueck zu den Vorschlaegen: auf den Vorschlag an derselben
     Stelle (nach Erfolg der naechste, nach einem Fehler derselbe), ohne
     Vorschlaege auf "Zur Kasse". Nur den von setBusy geretteten Fokus -
     hat der Kunde ihn inzwischen selbst bewegt, bleibt er dort.
     reveal: bei Tastatur/AT den Vorschlag im Scrollbereich sichtbar halten
     (Inhalt kann sich durch die neue Zeile verschoben haben). */
  function refocusUpsell(idx, reveal) {
    if (!isOpen()) return;
    var a = document.activeElement;
    if (a && a !== closeBtn && a !== document.body) return;
    var list = upsellControls();
    var target = list.length
      ? list[Math.min(Math.max(idx, 0), list.length - 1)]
      : panel.querySelector('.cart-drawer__checkout:not([disabled])');
    if (!target) return;
    try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
    if (reveal && document.activeElement === target) revealInBody(target, false);
  }

  drawer.addEventListener('click', function (e) {
    /* Zeile "Express-Checkout": auf-/zuklappen (Zustand fuer die Sitzung) */
    if (xpToggle && e.target.closest('[data-cart-express-toggle]') === xpToggle) {
      toggleExpress();
      return;
    }

    /* Groessen-Hinweis bestaetigt -> Checkout freigeben. Neu rendern statt
       nur den Button zu entsperren, damit Hinweis und Footer denselben
       Zustand zeigen. Sofort lokal (geaendert hat sich nur sessionStorage),
       sonst blieben offline Hinweis und gesperrtes "Zur Kasse" stehen;
       laeuft eine Aenderung, zeichnet deren Antwort mit der Freigabe.
       refresh() gleicht danach mit dem Server ab. */
    var ackBtn = e.target.closest('[data-size-ack]');
    if (ackBtn) {
      setAck(ackBtn.getAttribute('data-size-ack') || '');
      if (lastCart && mutating === 0) {
        try { renderCart(lastCart); } catch (err) { /* refresh zeichnet */ }
      }
      refresh().catch(noop);
      return;
    }

    var upsellBtn = e.target.closest('[data-upsell-add]');
    if (upsellBtn) {
      var vId = upsellBtn.dataset.variantId;
      if (!vId || upsellBtn.classList.contains('is-loading')) return;
      upsellBtn.classList.add('is-loading');
      /* Vor dem Add merken (siehe refocusUpsell/revealNewLine). detail 0 =
         per Tastatur ausgeloest: dann Fokus und Blick bei den Vorschlaegen
         lassen. Zeiger/Touch: zur neuen Zeile scrollen. */
      var upsellIdx  = upsellControls().indexOf(upsellBtn);
      var hadFocus   = document.activeElement === upsellBtn;
      var byPointer  = e.detail > 0;
      var keysBefore = lineKeys();
      addItem(vId, 1).then(function () {
        if (byPointer) {
          try { revealNewLine(keysBefore, vId); } catch (err) { /* nur Komfort */ }
        }
      }, noop).finally(function () {
        upsellBtn.classList.remove('is-loading');
        if (hadFocus) {
          try { refocusUpsell(upsellIdx, !byPointer); } catch (err) { /* nur Komfort */ }
        }
      });
      return;
    }

    var qtyBtn    = e.target.closest('.cart-drawer__qty-btn');
    var removeBtn = e.target.closest('.cart-drawer__remove');

    if (qtyBtn) {
      var itemQ = qtyBtn.closest('[data-line]');
      if (!itemQ) return;
      var keyQ  = itemQ.dataset.lineKey;
      if (!keyQ) return;
      var qtyEl = itemQ.querySelector('.cart-drawer__qty-value');
      var curr  = parseInt((qtyEl && qtyEl.textContent) || '1', 10);
      var isDecrease = qtyBtn.dataset.action !== 'increase';
      if (isDecrease && curr <= 1) return;
      var nextQ = isDecrease ? curr - 1 : curr + 1;
      /* alte Menge fuer restoreLast (Rollback ohne bekannten Stand) */
      itemQ.setAttribute('data-qty-was', String(curr));
      if (qtyEl) qtyEl.textContent = String(nextQ);
      itemQ.classList.add('is-loading');
      changeByKey(keyQ, nextQ).catch(noop);
      return;
    }

    if (removeBtn) {
      var itemR = removeBtn.closest('[data-line]');
      if (!itemR) return;
      var keyR  = itemR.dataset.lineKey;
      if (!keyR) return;
      itemR.classList.add('is-loading');
      changeByKey(keyR, 0).catch(noop);
    }
  });

  /* Event-Objekte nie als Optionen durchreichen */
  document.addEventListener('cart:open',  function () { openDrawer(); });
  document.addEventListener('cart:close', function () { closeDrawer(); });
  document.addEventListener('cart:add', function (e) {
    var d = e.detail || {};
    var id = d.variantId || d.id;
    if (!id) return;
    addItem(id, d.quantity || 1, { open: d.open !== false }).catch(noop);
  });

  /* Logos in der Zeile: Apple Pay zeigt Shopify nur auf Geraeten, die
     Apple Pay koennen (Safari/Apple). Sonst das Logo ENTFERNEN (nicht nur
     ausblenden), damit die 3-Logo-Regel unter 360 px (:nth-child) weiter
     die richtigen zaehlt. Die Wallets selbst (geschlossenes Shadow DOM)
     bleiben unberuehrt. canMakePayments kann werfen (z. B. im
     Editor-iframe) - dann wie ohne Apple Pay. */
  (function pruneXpLogos() {
    if (!xpToggle) return;
    var ap = xpToggle.querySelector('.cart-drawer__xp-logo[data-pi="apple_pay"]');
    if (!ap) return;
    var possible = false;
    try { possible = !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch (e) { possible = false; }
    if (!possible) ap.parentNode.removeChild(ap);
  })();

  /* Express-Zustand beim Seitenstart (gespeicherte Wahl) und beim Wechsel
     ueber 768 x 600 px (Drehen, Fenstergroesse) anwenden */
  syncExpressUI();
  if (XP_ROOMY) {
    if (typeof XP_ROOMY.addEventListener === 'function') XP_ROOMY.addEventListener('change', syncExpressUI);
    else if (typeof XP_ROOMY.addListener === 'function') XP_ROOMY.addListener(syncExpressUI);
  }

  /* Abgleich beim Seitenstart, mit Sequenznummer: kommt die Antwort nach
     oder waehrend eines Adds, zeichnet sie den aelteren Stand nicht. */
  (function initialSync() {
    var seq = ++cartSeq;
    fetchCart().then(function (cart) {
      if (!isCart(cart) || mutating > 0 || seq <= appliedSeq) return;
      appliedSeq = seq;
      lastCart = cart;
      updateCartCount(cart.item_count);
      updateExternalFsBars(cart.total_price);
      if (body) {
        var rendered = body.querySelectorAll('[data-line]').length;
        var actual   = cart.items.length;
        if (rendered !== actual) renderCart(cart);
      }
    }).catch(noop);
  })();

  /* Rueckkehr aus dem bfcache (Safari, Zurueck-Taste): Skripte laufen nicht
     neu, initialSync also auch nicht. Zaehler, Gratisversand-Leisten,
     lastCart (Wallets), Service-Zeilen und /cart (Reload ueber
     cart:updated) sonst auf altem Stand. refresh() zeichnet nur, wenn
     nichts laeuft (Sequenz und Taint bleiben gewahrt). Den Express-Zustand
     neu lesen: Er gilt fuer die Sitzung, eine andere Seite kann ihn
     inzwischen geaendert haben; syncExpressUI zieht zugleich eine
     Groessenaenderung aus der Zeit im bfcache nach. Bei gesperrtem
     sessionStorage liefert readXpOpen den Stand dieser Seite. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    xpUserOpen = readXpOpen();
    syncExpressUI();
    refresh().catch(noop);
  });
})();
